import { Box, styledComponent } from '@hermes/web-components'
import styled from 'styled-components'

export const BodyContainer = styledComponent(Box, { shouldForwardProp: (prop) => prop !== 'disablePadding' })<{
  disablePadding?: boolean
}>(({ theme, disablePadding = false }) => ({
  width: '100%',
  maxWidth: 'xl',
  padding: disablePadding ? '0' : '0 16px',
  margin: '0 auto',
  marginTop: '20px',
  [theme.breakpoints.down('sm')]: {
    padding: disablePadding ? '0' : '0 16px',
    marginTop: '12px'
  }
}))
export const MobileFilterBody = styledComponent(Box)({
  display: 'flex',
  flexDirection: 'column',
  padding: '0px 16px',

  '.MuiTypography-root': {
    marginBottom: '16px'
  }
})

export const FilterDrawerHeader = styledComponent(Box)(({ theme }) => ({
  display: 'inline-flex',
  justifyContent: 'space-between',
  padding: '16px',
  borderBottom: `1px solid ${theme.palette.divider}`,
  '.MuiTypography-root': {
    lineHeight: '25px'
  }
}))

export const ListContainer = styled(Box)`
  ul,
  ol {
    list-style-type: none;
    padding: 0;
    margin: 0;
  }
`
